import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { I18N } from '../Store/I18n/Types';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { login } from '../Store/User/Actions';
import { SvgIcon } from '@material-ui/core';
import { AdtrackLogoIcon } from '../Themes/svg/adtrack-logo';
import { Config } from '../config';
import { getTheme } from '../Themes';
import MuiTextField from '@material-ui/core/TextField';
import { NotificationBar } from '../Components/NotificationBarComponent';
import { INotificationBarState } from '../Store/NotificationBar/Types';
import { ILayoutState } from '../Store/Layout/Types';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  notificationBar: INotificationBarState;
}

interface IPropsFromDispatch {
  login: typeof login;
}

type AllProps = WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  RouteComponentProps<{}> &
  IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
  button: {
    margin: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    textTransform: 'uppercase',
  },
  card: {
    maxWidth: '40%',
    minWidth: '20%',
    marginTop: '50px',
  },
  cardContent: {
    width: '100%',
  },
  errorContainer: {
    width: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    color: 'red',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
  },
  media: {
    height: 140,
  },
});

const DenseTextField = styled(MuiTextField)`
  .MuiInputBase-input {
    padding: 4px 6px;
  }
  .MuiInputLabel-formControl {
    top: -7px;
    font-weight: 300;
  }
`;

const LoginPage: React.FC<AllProps> = (props) => {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const { classes, layout, notificationBar, login, i18n } = props;

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  const handleSubmit = () => {
    login(username, password);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  const theme = getTheme(layout.theme);
  let errorMessage: null | string = null;
  if (notificationBar.autherror) {
    errorMessage = i18n._(notificationBar.autherror.message as string);
  }

  return (
    <MD.Card className={classes.card}>
      <MD.CardActionArea></MD.CardActionArea>
      <MD.CardActions>
        <MD.CardContent className={classes.cardContent}>
          <MD.Typography gutterBottom={true} variant="h4" component="h2">
            <SvgIcon
              component={AdtrackLogoIcon}
              htmlColor={theme.palette.text.primary}
            />
          </MD.Typography>
          <form
            className={classes.form}
            noValidate={true}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <DenseTextField
              autoComplete="username"
              required
              label={i18n._('Username')}
              onChange={handleUsernameChange}
              value={username}
            />
            <DenseTextField
              autoComplete="off"
              required
              label={i18n._('Password')}
              margin="normal"
              onChange={handlePasswordChange}
              onKeyPress={handleKeyPress}
              type="password"
              value={password}
            />
            <MD.Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={handleSubmit}
            >
              {i18n._('Log in')}
            </MD.Button>
            <MD.Grid item xs style={{ textAlign: 'end' }}>
              <MD.Link
                target="_blank"
                href={`${Config.UsersUrl}/reset`}
                variant="body2"
              >
                {i18n._('Forgot password?')}
              </MD.Link>
            </MD.Grid>
            <MD.Grid className={classes.errorContainer}>{errorMessage}</MD.Grid>
          </form>
        </MD.CardContent>
      </MD.CardActions>
      <NotificationBar />
    </MD.Card>
  );
};

const mapStateToProps = ({ i18n, layout, notificationBar }: IApplicationState) => ({
  i18n: i18n.i18n,
  layout,
  notificationBar,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  login: (u: string, p: string) => dispatch(login(u, p)),
});

export const Login = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LoginPage));
